<template>
    <a-modal title="成品型号绑定" :visible="true" :footer="false" :width="600" @cancel='layerCancel'>
        <div>
            <div>系列型号：
                 <a-popover placement="top">
                    <template slot="content">
                        <p v-if="modelSpecification" style="max-width: 600px;word-wrap: break-word;word-break: break-all;overflow: hidden;">{{modelSpecification}}</p>
                    </template>
                    <span class="headerContent">{{modelSpecification}}</span>
                </a-popover>
            </div>
            <div class="select-box">
                <span>对应整机型号：</span>
                <a-select  showSearch @search="searchAction" @blur="blurAction" v-model="certModel" allowClear style="width: 300px">
                    <a-select-option v-for="item in selectList" :key="item.id" :value="item.certModel">
                        {{ item.certModel }}
                    </a-select-option>
                </a-select>
                <a-button icon="plus" type="primary" style="margin-left: 10px" @click="saveAction">绑定</a-button>
            </div>
            <p class="title">已绑定整机型号</p>
            <div class="table" v-if="dataList.length > 0">
                <table>
                    <tr>
                        <th>No</th><th>对应整机型号</th><th>操作</th>
                    </tr>
                    <tr v-for="(i, index) in dataList" :key="index">
                        <td>{{index + 1}}</td><td>{{i.certModel}}</td><td><a-icon type="close" style="color:#3385FF;cursor: pointer" @click="delAction(i.id)"/></td>
                    </tr>
                </table>
            </div>
            <div v-else class="empty">
                暂无数据
            </div>
        </div>
    </a-modal>
</template>
<script>

import {addSolveData, removeSolveData, getCertDetailData, getUnCertDetailData, getSolveSelectData} from '@/api/keyPart';

const align = 'center'
export default {
  props:{
    keyObj: Object,
    id: Number,
    modelSpecification: String
  }, 
  data() {
    return {
      certModel: '',
      dataList: [],
      selectList: []
    }
  },
  watch: {
    
  },
  mounted() {
      this.getDetailData();
      this.getSolveSelectData(this.id);
  },
  methods: {
    layerCancel() {
      this.$emit('hideAction');
    },
    searchAction(e) {
        this.certModel = e;
    },
    blurAction(e) {
        this.certModel = e;
    },
    getSolveSelectData(id) {
        getSolveSelectData(id)
            .then(res => {
                this.selectList = res;
            })
            .catch(err => {
                console.log(err);
            })
    },
    saveAction() {
        if (!this.certModel) {
            this.$message.error('请输入对应整机型号');
            return;
        }
        let keyType = this.keyObj.keyPieceType;
        let params = {
            "certModel": this.certModel,
            "certificateId": this.id,
            "modelInUseId": this.keyObj.modelInUseId? this.keyObj.modelInUseId: ''
        };
        if (keyType == '1') {
            params.keyPieceTestId = this.keyObj.id;
        } else {
            params.keyPieceCertificateId = this.keyObj.id;
        }
        this.addSolveData(params);
    },
    addSolveData(params) {
        addSolveData(params)
            .then(res => {
                this.$message.success('添加成功');
                this.$bus.$emit('ifDelSelect');
                this.certModel = '';
                this.getDetailData();
                this.getSolveSelectData(this.id);
            })
            .catch(err => {
                console.log(err);
            })
    },
    delAction(id) {
        this.removeSolveData(id);
    },
    removeSolveData(id) {
        removeSolveData(id)
            .then(res => {
                this.$message.success('删除成功');
                this.$bus.$emit('ifDelSelect');
                this.getDetailData();
                this.getSolveSelectData(this.id);
            })
            .catch(err => {
                console.log(err);
            })
    },
    getDetailData() {
        let keyType = this.keyObj.keyPieceType;
        if (!this.keyObj.modelInUseId) {
            this.keyObj.modelInUseId = '';
        } 
        if (keyType == '0') {
              getCertDetailData(this.id, this.keyObj.id, this.keyObj.modelInUseId)
                .then(res => {
                    this.dataList = res;
                })
                .catch(err => {
                    console.log(err);
                })
        } else {
            getUnCertDetailData(this.id, this.keyObj.id)
                .then(res => {
                    this.dataList = res;
                })
                .catch(err => {
                    console.log(err);
                })
        }
    }
  },
}
</script>
<style lang="less" scoped>
    .headerContent{
        line-height: 30px;
        display: inline-block;
        width: 450px;
        overflow: hidden;/*超出部分隐藏*/
        white-space: nowrap;/*不换行*/
        text-overflow:ellipsis;
        vertical-align: middle;
        cursor: pointer;
    }
    .title {
        margin: 15px 0;
        text-align: center;
        font-size: 16px;
        font-weight: 600;
    }
    .select-box {
        margin-top: 10px;
    }
    .table {
        width: 100%;
        min-height: 50px;
        max-height: 300px;
        overflow-y: auto;
        table {
            width: 100%;
            height: 100%;
            tr {
                width: 100%;
                text-align: left;
                height: 30px;
                line-height: 30px;
                td {
                    width: 60%;
                    height: 100%;
                    // border: 1px solid #f1f1f1;
                    padding: 0 20px;
                    overflow: hidden;/*超出部分隐藏*/
                    white-space: nowrap;/*不换行*/
                    text-overflow:ellipsis;
                    vertical-align: middle;
                }
                th {
                    padding: 0 20px;
                    height: 33px;
                    line-height: 33px;
                    background-color: #f2f2f2;
                }
                th:last-child {
                    text-align: right;
                }
                td:first-child {
                    width: 20%;
                }
                td:last-child {
                    width: 20%;
                    text-align: right;
                }
            }
            tr:hover {
                background-color: #f1f1f1;
            }
        }
    }
    .empty {
        height: 50px;
        line-height: 50px;
        text-align: center;
        background-color: #f2f2f2;
    }
</style>